import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import EditableBoothIcon from './editable-booth-icon';
import Stage from '../stage/stage';

/** @class HallLayout
  * A componet for positioning and scaling booths within the hall.
  */
export default class HallLayout extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of HallLayout.
    */
  constructor(props) {
    super(props);
    this.state = {booths: []}
    this.dataURL = `/expos/${this.props.expoID}/halls/${this.props.hallID}`;
  }
  /** @method componentWillMount
    * Binds the component state to the firebase database.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL + '/booths', 'booths')
    this.bindAsObject(this.dataURL, 'hall');
  }
  /** @method componentWillUnmount
    * Unbinds the component state from the firebase database.
    */
  componentWillUnmount() {
    this.unbind('booths');
    this.unbind('hall');
  }
  /** @method render
    * Renders the component.
    */
  render() {
    const booths = this.state.booths.map(booth => (
      <EditableBoothIcon key={booth.id}
        {...booth}
        dataURL={this.dataURL + '/booths/' + booth.id}
      />
    ))
    return (
      <div className="hall-layout">
        <label>Hall Layout</label>
        <Stage dataURL={`${this.dataURL}/stage`}>
          {booths}
        </Stage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hall-editor/hall-layout.js